export default "__VITE_ASSET__BxHzzrGt__"